export const GET_EARLY_PAYMENTS = 'GET_EARLY_PAYMENTS';
export const GET_EARLY_PAYMENT_BY_ID = 'GET_EARLY_PAYMENT_BY_ID';
export const EARLY_PAYMENT_ADMIN_VERIFICATION =
  'EARLY_PAYMENT_ADMIN_VERIFICATION';
